import React from 'react';
import styled from 'styled-components'
import BackButton from '../back-button';
import Contact from "../contact"

export default function StandardLayout({ children }) {
  return (
    <>
      <Contact />
      <Main>{children}</Main>
      <BackButton />
    </>
  );
}

// layout approach here: https://www.joshwcomeau.com/css/full-bleed/
const Main = styled.main`
  width: min(900px, 100%);
  margin: 0 auto;
  padding: 16rem 1.6rem 10rem;
  & > h1 {
    margin: 0 auto 10rem;
    max-width: 680px;
  }
  & > section {
    display: grid;
    grid-template-columns: 1fr min(680px, 100%) 1fr;
  }
  & section > * {
    grid-column: 2;
  }
  & > section + section {
    margin-top: 14rem;
  }
  & section > * + * {
    margin-top: 3.5rem;
  }
  & section > h5 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
  & section > ul {
    margin-top: 1.2rem;
  }
  & .gatsby-image-wrapper,
  & .video-container {
    width: 100%;
    grid-column: 1 / 4;
  }
  & .gatsby-image-wrapper {
    position: relative;
    border-radius: 16px;
    background-image: linear-gradient(250deg, #3C39B9 0%, rgba(138, 2, 125, 0.65) 100%);
    & img {
      position: absolute;
      top: 2px;
      right: 2px;
      bottom: 2px;
      left: 2px;
      border-radius: 14px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
    }
  }
  & .video-container {
    position: relative;
    width: 100%;
    height: min(500px, 56vw);
    border-radius: 16px;
    background-image: linear-gradient(250deg, #3C39B9 0%, rgba(138, 2, 125, 0.65) 100%);
    & video {
      object-fit: cover;
      position: absolute;
      top: 2px;
      right: 2px;
      bottom: 2px;
      left: 2px;
      border-radius: 14px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      background-color: var(--dark-color);
    }
  }
`